import { Box, Typography, useTheme } from "@mui/material";
import { addCommas } from "@persian-tools/persian-tools";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../../hooks/useRedux";
import WalletEmpty from "../../../../../media/images/icons/empty-wallet";
import LogoSe from "../../../../../media/images/logos/KarenTarabarNet-App.png";
import NotifSingleButton from "../../../../components/NotifSingleButton";

export default function DashboardHeader() {
  const navigate = useNavigate();
  const theme = useTheme();

  const { stock } = useAppSelector((state) => state.user);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          backgroundColor: "bgColor.white",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "4px",
          borderRadius: "12px",
        }}
      >
        <img width={170} src={LogoSe} alt="" />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "bgColor.white",
          padding: "4px",
          borderRadius: "8px",
          gap: "4px",
        }}
      >
        <Box
          onClick={() => navigate("../wallet")}
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: "8px 4px",
            borderRadius: "8px",
            gap: "4px",
          }}
        >
          <WalletEmpty color={theme.palette.textColor.main} />
          <Typography>{addCommas(stock || 0)} ریال</Typography>
        </Box>
        <NotifSingleButton path="/driver/notifications" />
      </Box>
    </Box>
  );
}
